
import ResourceFormSkeletonStyle from "./Skeletons.module.css"; 

const ResourceFormSkeleton = () => {
  return (
    <div className={ResourceFormSkeletonStyle.resourceFormSkeleton}>
      <div className={ResourceFormSkeletonStyle.resourceHeading}></div>
      <div className={ResourceFormSkeletonStyle.resourceInput}></div>
      <div className={ResourceFormSkeletonStyle.resourceUpload}></div>
      <div className={ResourceFormSkeletonStyle.resourceBtn}></div>
    </div>
  );
};

export default ResourceFormSkeleton;
